module.exports = __webpack_public_path__ + "fonts/Avenir-Heavy.15249ad.woff";